import { API_BASE_URL } from '../config/environment';

export const fetchInterclubs = async () => {
  const response = await fetch(`${API_BASE_URL}/interclubs`);
  if (!response.ok) {
    throw new Error('Failed to fetch interclubs');
  }
  return response.json();
};

/**
 * Fetch clubs, optionally filtered by one interclub or multiple (for multi-interclub series).
 * @param {string|string[]} interclubIdOrIds - Single interclub ID, or array of IDs for multi-interclub season
 */
export const fetchClubs = async (interclubIdOrIds = '') => {
  const ids = Array.isArray(interclubIdOrIds) ? interclubIdOrIds.filter(Boolean) : (interclubIdOrIds ? [interclubIdOrIds] : []);
  const url =
    ids.length === 0
      ? `${API_BASE_URL}/clubs`
      : ids.length === 1
        ? `${API_BASE_URL}/clubs?interclubId=${encodeURIComponent(ids[0])}`
        : `${API_BASE_URL}/clubs?interclubIds=${ids.map((id) => encodeURIComponent(id)).join(',')}`;
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error('Failed to fetch clubs');
  }
  return response.json();
};
